import { Clock, Sparkles } from 'lucide-react';

interface ComingSoonPageProps {
  title: string;
}

const ComingSoonPage = ({ title }: ComingSoonPageProps) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] text-center px-4 relative">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-coral-100/30 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-coral-50/40 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
      </div>

      {/* Content */}
      <div className="relative animate-fade-in">
        {/* Icon container */}
        <div className="relative mx-auto mb-8">
          <div className="w-24 h-24 bg-gradient-to-br from-coral-100 to-coral-50 rounded-3xl flex items-center justify-center shadow-warm-lg rotate-3 transition-transform hover:rotate-0 duration-500">
            <Clock className="w-10 h-10 text-coral-500" strokeWidth={1.5} />
          </div>
          {/* Floating sparkle */}
          <div className="absolute -top-2 -right-2 animate-bounce" style={{ animationDuration: '2s' }}>
            <Sparkles className="w-5 h-5 text-coral-400" />
          </div>
        </div>

        {/* Title */}
        <h1 className="text-3xl font-bold text-neutral-800 mb-3 tracking-tight">
          {title}
        </h1>

        {/* Subtitle */}
        <p className="text-neutral-500 max-w-md mx-auto text-[15px] leading-relaxed">
          We're crafting something special. This feature will be available soon.
        </p>

        {/* Status indicator */}
        <div className="mt-10 inline-flex items-center gap-3 px-5 py-2.5 bg-white rounded-full shadow-warm-md border border-coral-100/50">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-coral-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-coral-500"></span>
          </span>
          <span className="text-sm font-medium text-neutral-600">In Active Development</span>
        </div>

        {/* Progress dots */}
        <div className="mt-8 flex items-center justify-center gap-2">
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              className="w-2 h-2 rounded-full bg-coral-300 animate-pulse"
              style={{ animationDelay: `${i * 200}ms` }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ComingSoonPage;
